import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { QuiztimeApiService } from '../../services/quiztime-api.service';
import { LtiUserProfile } from '../../models/lti-user-profile.interface';
import { QuizReport, UserDetailReportView } from '../../models/user-detail-report-view';
import { UserQuizReportComponent } from '../components/user-quiz-report.component';
import { LtiUser } from '../../models/lti-user.interface';

@Component({
    selector: 'app-user-quiz-report-container',
    imports: [CommonModule, UserQuizReportComponent],
    template: `
    <app-user-quiz-report
      [isLoading]="state().isLoading"
      [user]="state().user"
      [profile]="state().profile"
      [quizReport]="state().quizReport"
      [hasQuizData]="state().hasQuizData"
    ></app-user-quiz-report>
  `
})
export class UserQuizReportContainerComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private api = inject(QuiztimeApiService);

  protected readonly state = signal<{
    isLoading: boolean;
    user: LtiUser | null;
    profile: LtiUserProfile | null;
    quizReport: QuizReport;
    hasQuizData: boolean;
  }>({
    isLoading: true,
    user: null,
    profile: null,
    quizReport: { enrollment_date: '', questions: [] },
    hasQuizData: false
  });

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const [quizGuid, userId] = [params.get('quizGuid'), params.get('userId')];
      if (quizGuid && userId) this.loadUserReport(quizGuid, userId);
    });
  }

  private loadUserReport(quizGuid: string, ltiUserId: string): void {
    this.state.update(s => ({ ...s, isLoading: true }));

    // Ensure we have valid parameters
    if (!quizGuid || !ltiUserId) {
      this.state.update(s => ({
        ...s,
        isLoading: false,
        hasQuizData: false
      }));
      return;
    }

    this.api.getUserQuizReport(quizGuid, ltiUserId).subscribe({
      next: (response: UserDetailReportView) => {
        this.state.set({
          isLoading: false,
          user: response.user || null,
          profile: response.profile || null,
          quizReport: response.quiz_report || { enrollment_date: '', questions: [] },
          hasQuizData: Boolean(response.quiz_report?.questions?.length)
        });
      },
      error: (error) => {
        console.error('Error loading user quiz report:', error);
        this.state.update(s => ({
          ...s,
          isLoading: false,
          hasQuizData: false
        }));
      }
    });
  }
}
